import { api } from "../api/requests";


// RETRIEVE ALL INSURERS
export function getAllInsurers(countryId: number,pageNumber?: number, pageSize?: number, ): Promise<any> {
  return api.get(`/admin/insurers/country/${countryId}${pageNumber ? `?pageNumber=${pageNumber}` : ''}${pageSize ? `&pageSize=${pageSize}` : ''}`);
}

export function getInsurerProfile(): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    api
      .get(`/admin/insurers/profile`)
      .then((response: any) => {
        resolve(response?.data.data);
      })
      .catch((error: Error) => {
        reject(error);
      });
  });
}

export function toggleInsurerStatus(insurerId: string, status: boolean): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    api
      .post(`/admin/insurers/${insurerId}/activate?active=${status}`)
      .then((response: any) => {
        resolve(response?.data);
      })
      .catch((error: Error) => {
        reject(error);
      });
  });
}
